import { render, staticRenderFns } from "./PanelForm.vue?vue&type=template&id=5f535ced&scoped=true"
import script from "./PanelForm.vue?vue&type=script&lang=ts"
export * from "./PanelForm.vue?vue&type=script&lang=ts"
import style0 from "./PanelForm.vue?vue&type=style&index=0&id=5f535ced&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f535ced",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f535ced')) {
      api.createRecord('5f535ced', component.options)
    } else {
      api.reload('5f535ced', component.options)
    }
    module.hot.accept("./PanelForm.vue?vue&type=template&id=5f535ced&scoped=true", function () {
      api.rerender('5f535ced', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Form/PanelForm.vue"
export default component.exports